import { ResourceType, Resource } from '../../../../graphql'
import { isResourceWithEntity } from './ResourcePicker'

type ResourceProps = {
	resource: Resource,
}

export function getResourceString( resource: Resource ) {
	if ( !isResourceWithEntity( resource ) ) {
		return ''
	}

	if ( resource.resourceType ) {
		if ( resource.resourceType === ResourceType.Es ) {
			return 'Everything'
		}
		return `${resource.entity.name} (${resource.resourceType})`
	}

	return resource.entity.name
}

export default function ResourceDisplay( { resource }: ResourceProps ) {
	return <span>{getResourceString( resource )}</span>
}
